<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import { useMapGetter } from 'dashboard/composables/store';

import Button from 'dashboard/components-next/button/Button.vue';
import ContactNoteItem from './ContactNoteItem.vue';

const emit = defineEmits(['viewAll']);

const { t } = useI18n();
const route = useRoute();

const currentUser = useMapGetter('getCurrentUser');
const notesGetter = useMapGetter('contactNotes/getAllNotesByContactId');

const allNotes = computed(
  () => notesGetter.value(route.params.contactId) || []
);
const notes = computed(() => allNotes.value.slice(0, 3));

const getWrittenBy = note => {
  const isCurrentUser = note?.user?.id === currentUser.value.id;
  return isCurrentUser
    ? t('CONTACTS_LAYOUT.SIDEBAR.NOTES.YOU')
    : note?.user?.name || 'Bot';
};
</script>

<template>
  <div class="flex flex-col">
    <div v-if="notes.length" class="divide-y divide-n-weak">
      <ContactNoteItem
        v-for="note in notes"
        :key="note.id"
        class="py-3"
        :note="note"
        :written-by="getWrittenBy(note)"
        collapsible
      />
    </div>
    <p v-else class="py-2 text-sm text-n-slate-11">
      {{ t('CONTACTS_LAYOUT.OVERVIEW.NOTES_EMPTY') }}
    </p>
    <Button
      v-if="allNotes.length"
      variant="link"
      color="blue"
      size="sm"
      class="self-start mt-2 hover:no-underline"
      :label="t('CONTACTS_LAYOUT.OVERVIEW.VIEW_ALL')"
      @click="emit('viewAll')"
    />
  </div>
</template>
